import { PayNowModalContent } from "../PayNowModal/PayNowModal";
import { ProvisionSpinModal } from "./ProvisionSpin";
import { SearchFlowContextProvider } from "./SearchFlow/SearchFlowContextProvider";
import { TakePaymentModalContentNonPms, TakePaymentModalContentPms } from "./TakePaymentModal";
import { create, useModal } from "@ebay/nice-modal-react";
import { useMasonFlag } from "utils/useMasonFlag";
import { useProvisionTransactor } from "api/clients/useProvisionTransactor";

export type TakePaymentTabType = "patient-payment" | "insurance-payment";

export const TakePaymentModal = create(() => {
    const pmsIntegrated = useMasonFlag();

    return (
        <SearchFlowContextProvider>
            {pmsIntegrated ? <TakePaymentModalContentPms /> : <TakePaymentModalContentNonPms />}
        </SearchFlowContextProvider>
    );
});

export const TakePaymentModalByPmsId = create<{ readonly pmsId: string }>(({ pmsId }) => {
    const modal = useModal();
    const { data: patientId, isPending: isProvisioning } = useProvisionTransactor(pmsId, undefined);

    return patientId ? (
        <PayNowModalContent modal={modal} patientId={patientId} />
    ) : (
        /* Auto-Provisioning P/RP based on VyneSync patient... */
        <ProvisionSpinModal modal={modal} isProvisioning={isProvisioning} />
    );
});
